import React, { FC } from 'react';
import { localized } from 'shared/state/i18n/i18n';
import { SkioldFormsWrapper } from 'web/view/components/skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { FormRow } from 'web/view/components/skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';

import { useSelector } from 'react-redux';
import { Equipment, IGpeDashboardSettingItem } from 'shared/api/api';
import { Building } from 'shared/state/ducks/locations';
import { SharedAppState } from 'shared/state/store.shared';
import { SkioldFormIntegerInput } from 'web/view/components/skiold-components/skiold-integer-input/skiold-form-integer-input';

interface Props {
	item: IGpeDashboardSettingItem;
	onChange: (item) => void;
	buildings: Building[];
}

export const GpeDashboardSettings: FC<Props> = React.memo(({ item, onChange }) => {
	const hasDistriwin = useSelector((state: SharedAppState) =>
		state.processEquipments.entities.find(e => e.equipment === Equipment.Distriwin),
	);
	const getFormRows = () => {
		let formRows = new Array<FormRow>();

		formRows.push(getWorkListHeader());

		if (hasDistriwin) {
			formRows.push(getSubGoalRow());
		}

		formRows.push(getPredictionRow());
		return formRows;
	};

	const onChangeSubGoal = (value: number | undefined) => {
		onChange({ ...item, subGoal: value });
	};

	const getSubGoalRow = (): FormRow => {
		return {
			name: localized('DashboardSubGoal'),
			component: <SkioldFormIntegerInput text={item.subGoal} onChangeNumber={onChangeSubGoal} />,
		};
	};
	const onChangePrediction = (value: number | undefined) => {
		onChange({ ...item, predictedWeightAtSale: value });
	};

	const getPredictionRow = (): FormRow => {
		return {
			name: localized('DashboardExpectedWeight'),
			component: <SkioldFormIntegerInput text={item.predictedWeightAtSale} onChangeNumber={onChangePrediction} />,
		};
	};

	const getWorkListHeader = (): FormRow => {
		return {
			header: localized('Dashboard'),
		};
	};

	return <SkioldFormsWrapper formRows={getFormRows()} containerClassName="wrapper-container" />;
});
